import {
  Avatar,
  Badge,
  Button,
  Col,
  Divider,
  Popover,
  Row,
  Select,
  Skeleton,
  Tooltip,
  Typography,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserCircleAddIcon from "../../Theme/CustomIcons/Icons/Users/UserCircleAddIcon";
import NutIcon from "../../Theme/CustomIcons/Icons/Settings/NutIcon";
import { css } from "@emotion/css";
import { Link, useNavigate } from "react-router-dom";
import { adminOpenCompanyAction } from "../../store/action/admin/employeesAction";
import LogoutIcon from "../../Theme/CustomIcons/Icons/Arrow/LogoutIcon";
import UserEditIcon from "../../Theme/CustomIcons/Icons/Users/UserEditIcon";
import ProfileCirlceIcon from "../../Theme/CustomIcons/Icons/Users/ProfileCirlceIcon";
import { sharedLogoutAction } from "../../store/action/shared/authAction";
import BuildingsIcon from "../../Theme/CustomIcons/Icons/Building/BuildingsIcon";
import RepeatIcon from "../../Theme/CustomIcons/Icons/Arrow/RepeatIcon";
// import TeamInviteModal from "../modals/admin/teams/teamInviteModal";
import ArrowLeft from "../../Theme/CustomIcons/Icons/Arrow/ArrowLeft";
import BruchIcon from "../../Theme/CustomIcons/Icons/Design,tools/BruchIcon";
import { TranslatorCompanyTag } from "../../languageTranslator/LanguageTranslatorTags";
import ThemeSettingsPopup from "../../Global/Settings/Component/ThemeSettingsPopup";

import CloseCircleIcon from "../../Theme/CustomIcons/Icons/Essetional/CloseCircleIcon";
import CustomLoaderIcon from "../../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";
import { themeAction } from "../../store/action/admin/themeActions";
import { langaugeTanslatorAction } from "../../store/action/admin/languageTranslatorActions";
import LanguageIcon from "../../Theme/CustomIcons/Icons/Type,Paragraph,Character/LanguageIcon";
import LangaugeSettingsPopup from "../../Global/Settings/Component/LanguageSettingsPopup";
import GlobeIcon from "../../Theme/CustomIcons/Icons/Location/GlobeIcon";
import ArrowLeftCircleIcon from "../../Theme/CustomIcons/Icons/Arrow/ArrowLeftCircleIcon";
import ArrowRightCircleIcon from "../../Theme/CustomIcons/Icons/Arrow/ArrowRightCircleIcon";
import ArrowRightIcon from "../../Theme/CustomIcons/Icons/Arrow/ArrowRightIcon";
import { toggleUserTabSwitchAction } from "../../store/action/user/tabSwitchAction";
import {
  colorCodes,
  textColorCodes,
} from "../../Global/GPTComponents/randomColors";
import {
  changeUserCompanyAction,
  getAllUserCompanyAction,
  getCompanyOwnerAction,
} from "../../store/action/user/companyActions";
import {
  getCompanySettAction,
  getSettingForDepAction,
} from "../../store/action/manager/settingAction";
import { getUserPersonalInfoAction } from "../../store/action/user/personalInfoAction";
import {
  userAllUserStatusAction,
  userProjectAction,
} from "../../store/action/user/projectAction";
import {
  userCompleteTimeTodoAction,
  userNotCompleteTodoAction,
  userTodayTodoAction,
  userTotalCompleteTodoAction,
} from "../../store/action/user/todoAction";
import { userProductAction } from "../../store/action/user/productAction";
import {
  userDashTodayTimesAction,
  userRangeDashAction,
  userTodayTimesAction,
  userWeekDashAction,
} from "../../store/action/user/timesAction";
import {
  userScreenDashListAction,
  userScreenListAction,
} from "../../store/action/user/screenshot";
import { getDepartments } from "../../store/action/user/departAction";
import { userAppTrackAction } from "../../store/action/user/appTrackActions";
import { getAnnouncedAction } from "../../store/action/shared/announcementAction";
import {
  GetLeavesByCompanyAction,
  GetLeavesByUsersAction,
  GetLeavesSettingByUsersAction,
} from "../../store/action/user/leaveManagmentActions";
import {
  userAddMarkAction,
  userGetSettingAction,
} from "../../store/action/user/settingAction";

const { Text } = Typography;
const { Option } = Select;
const companyData = [
  {
    logo: {
      url: "https://catalyst-app-bucket.s3.ap-south-1.amazonaws.com/screenshot_6450c0dd83f95e00139eaa85_1709589634051_MaxHR%20Emblem.png",
      public_id:
        "screenshot_6450c0dd83f95e00139eaa85_1709589634051_MaxHR Emblem.png",
    },
    _id: "6450c0dd83f95e00139eaa85",
    archived: false,
    ssTime: "20",
    companyName: "Meet Max Solutions LLC",
    employeeNumber: "11-24",
    ownerId: [
      {
        _id: "6450c06583f95e00139eaa7d",
      },
    ],
    created_at: "2023-05-02T07:50:54.378Z",
    updatedAt: "2024-07-06T04:18:20.274Z",
    __v: 189,
    uniqueIdentifier: "meetmax",
    maxprofileSignup: true,
    address: "Introduction",
    industry: "recruitment",
    modules: [
      "payroll",
      "time_tracking_mobile",
      "recruitment_companies",
      "report",
      "time",
      "new_document",
      "airTicket",
      "shift",
      "geo_tracking",
      "announcement",
      "recruitment",
      "advanced_leave",
      "searchbar",
      "voice",
    ],
  },
];
function ProfileDropDown(props) {
  const dispatch = useDispatch();
  const router = useNavigate();
  const getUserCompaniesList = useSelector(
    (state) => state.getUserCompaniesList
  );
  const { getUserCompaniesInfo } = getUserCompaniesList;
  const [open, setOpen] = useState(false);
  const [visibleCompanies, setVisibleCompanies] = useState(5);
  const [viewCompanies, setViewCompanies] = useState(false);
  const [allCompanies, setallCompanies] = useState([]);
  const [profileDropDownCompanies, setProfileDropDownCompanies] = useState([]);
  const [profileDropDownAllCompanies, setProfileDropDownAllCompanies] =
    useState([]);
  const [viewThemeSettings, setViewThemeSettings] = useState(false);
  const [viewLanguageSettings, setViewLanguageSettings] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const getAllCompanyList = useSelector((state) => state.getAllCompanyList);
  const { getAllCompaniesLoading, getAllCompaniesInfo } = getAllCompanyList;
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const themeDefault = useSelector((state) => state.themeDefault);
  const { sharedUserInfo } = sharedLogin;
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const adminArchiveCompanyList = useSelector(
    (state) => state.adminArchiveCompanyList
  );

  const { archiveCompanyInfo } = adminArchiveCompanyList;
  const openAnotherCompanyList = useSelector(
    (state) => state.openAnotherCompanyList
  );
  const { openAnotherCompanyLoading } = openAnotherCompanyList;
  const empAllList = useSelector((state) => state.empAllList);
  const { allEmpLoading, allEmpInfo } = empAllList;

  const { translations } = getLanguageTranslatorList;
  const textHover = css`
    display: flex !important;
    cursor: pointer;

    padding: 3px 0;
    gap: clamp(4px, 0.7vw, 12px);
    transition: border 0.3s, color 0.3s;
    .ant-typography {
      transition: color 0.3s;
    }

    &:hover {
      color: ${themeDefault?.info?.colorPrimary};
      .ant-typography {
        color: ${themeDefault?.info?.colorPrimary};
      }
    }
  `;
  const selected = css`
    display: flex !important;

    gap: clamp(4px, 0.7vw, 12px);
    cursor: pointer;
    transition: border 0.3s, color 0.3s;
    .ant-typography {
      transition: color 0.3s;
    }

    color: ${themeDefault?.info?.colorPrimary};
    .ant-typography {
      color: ${themeDefault?.info?.colorPrimary};
    }
  `;
  let CompanyLogo;
  let CompanyName;
  let userEmail;
  let profileImage;
  let userName;
  let compId;
  let userType = "";
  let empCompanies = sharedUserInfo?.empCompanies;
  if (sharedUserInfo?.payload?.company) {
    CompanyLogo = sharedUserInfo?.payload?.company?.logo;
    CompanyName = sharedUserInfo?.payload?.company?.companyName;
    userEmail = sharedUserInfo?.payload?.email;
    profileImage = sharedUserInfo?.payload?.profileImage;
    userName = sharedUserInfo?.payload?.name;
  } else {
    CompanyLogo =
      empCompanies && empCompanies.length > 0
        ? empCompanies[0]?.companyId?.logo
        : "";
    CompanyName =
      empCompanies && empCompanies.length > 0
        ? empCompanies[0]?.companyId?.companyName
        : "";
    userEmail = sharedUserInfo?.payload?.email;
    profileImage = sharedUserInfo?.payload?.profileImage;
    userName = sharedUserInfo?.payload?.name;
  }
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }
  if (sharedUserInfo?.payload?.company) {
    compId = sharedUserInfo?.payload?.company?._id
      ? sharedUserInfo?.payload?.company?._id
      : "";
  } else {
    compId = sharedUserInfo?.empCompanies[0]?.companyId?._id
      ? sharedUserInfo?.empCompanies[0]?.companyId?._id
      : "";
  }
  const isDummyLogo = CompanyLogo?.url === "dummy";
  const isDummypfp = profileImage?.url === "dummy";
  const companyInitials = CompanyName?.slice(0, 2).toUpperCase();
  const userInitials =
    userName?.firstName?.slice(0, 1).toUpperCase() +
    " " +
    userName?.lastName?.slice(0, 1).toUpperCase();
  const colorIndex = 2 % colorCodes.length;
  const employeeColor = colorCodes[colorIndex];
  const textColor = textColorCodes[colorIndex];
  const handleOpenChange = (newOpen) => {
    setVisibleCompanies(5);
    setOpen(newOpen);
    setViewThemeSettings(false);
    setViewCompanies(false);
    handleClose();
  };
  const onClicked = async (event) => {
    if (event === "100") {
      router("/admin/onboarding-wizard/company-detail");
    } else {
      await dispatch(adminOpenCompanyAction(event));
      const themeData = await dispatch(themeAction());
      dispatch(langaugeTanslatorAction(themeData?.language || "en"));
    }
  };
  // const loadMoreCompanies =;

  // const allCompanies = companyData;
  useEffect(() => {
    const allComp =
      (getAllCompaniesInfo?.length > 0
        ? getAllCompaniesInfo
        : archiveCompanyInfo?.length > 0
        ? archiveCompanyInfo
        : []) || [];
    setallCompanies(allComp || []);
    const profileDropDownCompanies = allComp
      ?.slice(0, visibleCompanies)
      ?.map((item, index) => {
        const isSelected = sharedUserInfo?.payload?.company?._id === item?._id;
        const isDummyLogo = item?.logo?.url === "dummy";
        const companyInitials = item?.companyName?.slice(0, 2).toUpperCase();
        const isArchived = item?.archived === true;

        const colorIndex = index % colorCodes.length;
        const employeeColor = colorCodes[colorIndex];
        const textColor = textColorCodes[colorIndex];
        if (!isSelected && isArchived) return null;
        if (isSelected) return null;
        return (
          <Col
            className={isSelected ? selected : textHover}
            span={24}
            style={{
              marginBottom: "5px",
              display: "flex",
              alignItems: "center",
            }}
            key={item?._id}
            onClick={() => onClicked(item?._id)}
          >
            <Avatar
              size={20}
              shape="square"
              style={{
                background: employeeColor,
                color: textColor,
              }}
              icon={
                isDummyLogo ? (
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "normal",
                      marginTop: "0px",
                      cursor: "pointer",
                      textTransform: "uppercase",
                    }}
                  >
                    {companyInitials}
                  </p>
                ) : (
                  <img
                    src={item?.logo?.url}
                    alt="Profile Pic"
                    style={{ borderRadius: "8px" }}
                  />
                )
              }
            />
            <Text>{item?.companyName}</Text>
          </Col>
        );
      });
    const profileDropDownAllCompanies = allComp?.map((item, index) => {
      const isSelected = sharedUserInfo?.payload?.company?._id === item?._id;
      const isDummyLogo = item?.logo?.url === "dummy";
      const companyInitials = item?.companyName?.slice(0, 2).toUpperCase();
      const isArchived = item?.archived === true;

      const colorIndex = index % colorCodes.length;
      const employeeColor = colorCodes[colorIndex];
      const textColor = textColorCodes[colorIndex];
      if (!isSelected && isArchived) return null;
      if (isSelected) return null;
      return (
        <Col
          className={isSelected ? selected : textHover}
          span={24}
          style={{
            marginBottom: "5px",
            display: "flex",
            alignItems: "center",
          }}
          key={item?._id}
          onClick={() => onClicked(item?._id)}
        >
          <Avatar
            size={20}
            shape="square"
            style={{
              background: employeeColor,
              color: textColor,
            }}
            icon={
              isDummyLogo ? (
                <p
                  style={{
                    fontSize: "10px",
                    fontWeight: "normal",
                    marginTop: "0px",
                    cursor: "pointer",
                    textTransform: "uppercase",
                  }}
                >
                  {companyInitials}
                </p>
              ) : (
                <img
                  src={item?.logo?.url}
                  alt="Profile Pic"
                  style={{ borderRadius: "8px" }}
                />
              )
            }
          />
          <Text>{item?.companyName}</Text>
        </Col>
      );
    });
    setProfileDropDownAllCompanies(profileDropDownAllCompanies);
    setProfileDropDownCompanies(profileDropDownCompanies);
  }, [archiveCompanyInfo, getAllCompaniesInfo]);

  const [AllUserComp, setAllUserComp] = useState([]);
  const [profileDDAllUserComp, setProfileDDAllUserComp] = useState([]);
  const [profileDDUserComp, setprofileDDUserComp] = useState([]);
  let companyId;

  if (sharedUserInfo?.payload?.company) {
    companyId = sharedUserInfo?.payload?.company?._id;
  } else if (sharedUserInfo?.empCompanies.length > 0) {
    companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
  }

  useEffect(() => {
    const allComp =
      (getUserCompaniesInfo?.length > 0 ? getUserCompaniesInfo : []) || [];
    setAllUserComp(allComp || []);

    const currentCompanyId = sharedUserInfo?.payload?.company?._id;

    const profileDropDownCompanies = allComp
      ?.slice(0, visibleCompanies)
      ?.filter(
        (item) => item?._id !== currentCompanyId && item?._id !== companyId
      ) // Exclude both current and selected branch
      .map((item, index) => {
        const isDummyLogo = item?.logo?.url === "dummy";
        const companyInitials = item?.companyName?.slice(0, 2).toUpperCase();
        const colorIndex = index % colorCodes.length;
        const employeeColor = colorCodes[colorIndex];
        const textColor = textColorCodes[colorIndex];
        return (
          <Col
            className={textHover}
            span={24}
            style={{
              marginBottom: "5px",
              display: "flex",
              alignItems: "center",
            }}
            key={item?._id}
            onClick={() => handleSelect(item?._id)}
          >
            <Avatar
              size={20}
              shape="square"
              style={{
                background: employeeColor,
                color: textColor,
              }}
              icon={
                isDummyLogo ? (
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "normal",
                      marginTop: "0px",
                      cursor: "pointer",
                      textTransform: "uppercase",
                    }}
                  >
                    {companyInitials}
                  </p>
                ) : (
                  <img
                    src={item?.logo?.url}
                    alt="Profile Pic"
                    style={{ borderRadius: "8px" }}
                  />
                )
              }
            />
            <Text>{item?.companyName}</Text>
          </Col>
        );
      });

    const profileDropDownAllCompanies = allComp
      .filter(
        (item) => item?._id !== currentCompanyId && item?._id !== companyId
      ) // Exclude both current and selected branch
      .map((item, index) => {
        const isDummyLogo = item?.logo?.url === "dummy";
        const companyInitials = item?.companyName?.slice(0, 2).toUpperCase();
        const colorIndex = index % colorCodes.length;
        const employeeColor = colorCodes[colorIndex];
        const textColor = textColorCodes[colorIndex];
        return (
          <Col
            className={textHover}
            span={24}
            style={{
              marginBottom: "5px",
              display: "flex",
              alignItems: "center",
            }}
            key={item?._id}
            onClick={() => handleSelect(item?._id)}
          >
            <Avatar
              size={20}
              shape="square"
              style={{
                background: employeeColor,
                color: textColor,
              }}
              icon={
                isDummyLogo ? (
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "normal",
                      marginTop: "0px",
                      cursor: "pointer",
                      textTransform: "uppercase",
                    }}
                  >
                    {companyInitials}
                  </p>
                ) : (
                  <img
                    src={item?.logo?.url}
                    alt="Profile Pic"
                    style={{ borderRadius: "8px" }}
                  />
                )
              }
            />
            <Text>{item?.companyName}</Text>
          </Col>
        );
      });

    setProfileDDAllUserComp(profileDropDownAllCompanies);
    setprofileDDUserComp(profileDropDownCompanies);
  }, [getUserCompaniesInfo, companyId]);

  const themeCreateList = useSelector((state) => state.themeCreateList);

  const handleLangClick = () => {
    setViewLanguageSettings(!viewLanguageSettings);
  };
  const handleClose = () => {
    setViewLanguageSettings(false); // Close the Popover
  };
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language); // Set the selected language
    handleClose(); // Close the popup
  };

  const [toggleKey, setToggleKey] = useState(0);
  const handleSelect = async (companyId) => {
    try {
      await dispatch(changeUserCompanyAction(companyId));
      const themeData = await dispatch(themeAction());
      dispatch(langaugeTanslatorAction(themeData?.language || "en"));
      setToggleKey((prev) => prev + 1);
      //message.success("Company changed successfully"); // Success message
      setOpen(false);
    } catch (error) {
      message.error(error?.message || "Failed to change company");
    }
  };
  useEffect(() => {
    if (sharedUserInfo?.payload?.type === "user") {
      const companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      // Dispatch all actions with the new company ID
      dispatch(getSettingForDepAction(companyId));
      dispatch(getUserPersonalInfoAction(companyId));
      dispatch(userProjectAction(companyId));
      dispatch(userNotCompleteTodoAction(companyId));
      dispatch(userTotalCompleteTodoAction(companyId));
      dispatch(userCompleteTimeTodoAction(companyId));
      dispatch(userTodayTodoAction(companyId));
      dispatch(userProductAction(companyId));
      dispatch(userTodayTimesAction(companyId));
      dispatch(userRangeDashAction(companyId));
      dispatch(userScreenListAction(companyId));
      dispatch(getDepartments(companyId));
      dispatch(getAllUserCompanyAction(companyId));
      dispatch(userWeekDashAction(companyId));
      dispatch(userScreenDashListAction(companyId));
      dispatch(userDashTodayTimesAction(companyId));
      dispatch(userAppTrackAction(companyId));
      dispatch(userGetSettingAction(companyId));
      dispatch(getAnnouncedAction(companyId));
      dispatch(getCompanySettAction(companyId));
      dispatch(GetLeavesSettingByUsersAction(companyId));
      dispatch(GetLeavesByUsersAction(companyId));
      dispatch(GetLeavesByCompanyAction(companyId));
      dispatch(getCompanyOwnerAction(companyId));
      dispatch(userAllUserStatusAction());
      dispatch(userAddMarkAction());
    }
  }, [toggleKey]);
  const roleFeatures = sharedUserInfo.userAccess || [];
  const DropDown = () => {
    const companyInitials = CompanyName?.companyName?.slice(0, 2).toUpperCase();
    let loading =
      themeCreateList?.loading ||
      getLanguageTranslatorList?.loading ||
      themeDefault?.loading;
    let popoverWidth = "400px";
    if (translations === "rtl") {
      popoverWidth = "425px";
    } else {
      popoverWidth = "400px";
    }
    const toggleUserTabSwitchList = useSelector(
      (state) => state.toggleUserTabSwitchList
    );
    const { toggleValue } = toggleUserTabSwitchList;

    const logoutFunction = async () => {
      const data = {
        browserToken: JSON.parse(localStorage.getItem("browserToken")),
        logoutApp: "auth",
      };
      await dispatch(sharedLogoutAction(data));
      // router("/login");
      window.location.href = "/login";
    };
    return (
      <div
        className={css`
          width: ${viewThemeSettings ? "440px" : "clamp(225px, 20vw, 335px)"};

          .icon {
            font-size: clamp(10px, 1.1vw, 16px) !important;
          }
          .ant-popover-inner {
            padding: 0px;
          }
          .antd-popover {
            z-index: 999 !important;
          }
          border-radius: ${themeDefault?.info?.borderRadius}px;
        `}
      >
        {props.fromOnboarding ? (
          <Row>
            <Col
              span={24}
              className={css`
                border-bottom: ${themeDefault?.info?.newConfig
                  ?.cardborder} !important;
              `}
            >
              <Row
                className={css`
                  padding: 0 15px !important;
                  padding-bottom: 2px !important;
                  padding-top: 10px !important;

                  display: flex;
                  gap: 10px;
                `}
              >
                <Col
                  className={css`
                    .ant-skeleton
                      .ant-skeleton-content
                      .ant-skeleton-paragraph {
                      margin: 0px;
                    }
                    .ant-skeleton
                      .ant-skeleton-content
                      .ant-skeleton-paragraph
                      > li {
                      height: 10px;
                    }
                  `}
                  span={24}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <Avatar
                    size={35}
                    shape="square"
                    style={{ background: "#260b3b", color: "white" }}
                    icon={
                      isDummyLogo ? (
                        <p
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            marginTop: "0px",
                            cursor: "pointer",
                            textTransform: "uppercase",
                          }}
                        >
                          {CompanyName?.slice(0, 2).toUpperCase()}
                        </p>
                      ) : (
                        <img
                          src={CompanyLogo?.url}
                          style={{ borderRadius: "8px" }}
                          alt="Profile Pic"
                        />
                      )
                    }
                  />
                  <Row
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems:
                        translations?.direction === "rtl" ? "0" : "flex-start",
                    }}
                  >
                    <Text style={{ fontWeight: 500 }}>{CompanyName}</Text>
                    <Col>
                      {allEmpLoading ? (
                        <Skeleton
                          active
                          title={false}
                          paragraph={{ rows: 1, width: "50%" }}
                        />
                      ) : (
                        allEmpInfo && (
                          <Text type="secondary">
                            {allEmpInfo.length}{" "}
                            <TranslatorCompanyTag>
                              Employees
                            </TranslatorCompanyTag>
                          </Text>
                        )
                      )}
                    </Col>
                  </Row>
                </Col>
                {userType !== "user" && (
                  <Col span={24}>
                    {}
                    <Row gutter={[8, 4]}>
                      <Col
                        span={
                          userType === "admin" ||
                          (userType !== "user" && roleFeatures?.includes("1"))
                            ? 12
                            : 24
                        }
                      >
                        <Link
                          to={`/${
                            userType === "admin" ? userType : "manager"
                          }/organization-settings/`}
                        >
                          <Button
                            style={{ width: "100%" }}
                            icon={<NutIcon className="icon" />}
                          >
                            <TranslatorCompanyTag>
                              Org. Setting
                            </TranslatorCompanyTag>
                          </Button>
                        </Link>
                      </Col>
                      {userType === "admin" ||
                      (userType !== "user" && roleFeatures?.includes("1")) ? (
                        <Col span={12}>
                          {/* <TeamInviteModal type="button" /> */}
                        </Col>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </Col>
                )}
              </Row>
            </Col>
            {/* {userType !== "user" && (
              <>
                {archiveCompanyInfo?.length > 1 ||
                getAllCompaniesInfo?.length > 1 ? (
                  <Col
                    span={24}
                    className={css`
                      background: ${themeDefault?.info?.newConfig
                        ?.profileDropDownSecondaryBackground};
                      backdrop-filter: blur(50px);
                      border-bottom: ${themeDefault?.info?.newConfig
                        ?.cardborder} !important;
                    `}
                  >
                    <Row
                      className={css`
                        padding: 0 15px !important;
                        padding-bottom: 0px !important;
                        display: flex;
                        gap: clamp(3px, 0.33vw, 5px);
                      `}
                    >
                      <Col
                        span={24}
                        style={{
                          marginTop: "5px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text>
                          <TranslatorCompanyTag>
                            Switch Company
                          </TranslatorCompanyTag>
                        </Text>
                        <RepeatIcon size="small" />
                      </Col>

                      <Col span={24}>
                        {profileDropDownCompanies}
                        {allCompanies.length > visibleCompanies && (
                          <div
                            style={{
                              margin: "5px 0",
                            }}
                          >
                            <Text
                              className={css`
                                &:hover {
                                  .ant-typography {
                                    color: ${themeDefault?.info?.newConfig
                                      ?.colorPrimary};
                                  }
                                }
                              `}
                              onClick={() => {
                                const allComp =
                                  (getAllCompaniesInfo?.length > 0
                                    ? getAllCompaniesInfo
                                    : archiveCompanyInfo?.length > 0
                                    ? archiveCompanyInfo
                                    : []) || [];
                                setVisibleCompanies(allComp);
                                // setVisibleCompanies(companyData.lenght);
                                setViewCompanies(true);
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                              }}
                            >
                              <TranslatorCompanyTag>
                                Show More
                              </TranslatorCompanyTag>
                            </Text>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  ""
                )}
              </>
            )} */}
            <Col
              span={24}
              className={css`
                background: transparent;
                backdrop-filter: blur(10px);
                border-bottom: ${themeDefault?.info?.newConfig
                  ?.cardborder} !important;
              `}
            >
              <Row
                className={css`
                  padding: 0 15px !important;
                  padding-bottom: 0px !important;
                  padding-top: 5px !important ;
                  display: flex;
                  gap: clamp(3px, 0.33vw, 5px);
                `}
              >
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <Text>{userEmail}</Text>
                </Col>
                <Col span={24}>
                  <Row>
                    {/* <Col span={24}>
                      {userType !== "user" ? (
                        <Link
                          className={textHover}
                          to={
                            sharedUserInfo?.payload?.type === "admin"
                              ? `/admin/settings/`
                              : sharedUserInfo?.payload?.type !== "user"
                              ? `/manager/settings/`
                              : sharedUserInfo?.payload?.type === "user"
                              ? `/user/settings/`
                              : ""
                          }
                        >
                          <ProfileCirlceIcon className="icon" />
                          <Text>
                            <TranslatorCompanyTag>
                              Profile Settings
                            </TranslatorCompanyTag>
                          </Text>
                        </Link>
                      ) : (
                        <div
                          onClick={() => {
                            setOpen(false);
                            dispatch(
                              toggleUserTabSwitchAction("General Settings")
                            );
                          }}
                          className={css`
                            display: flex !important;
                            cursor: pointer;

                            padding: 3px 0;
                            gap: clamp(4px, 0.7vw, 12px);
                            transition: border 0.3s, color 0.3s;
                            .ant-typography {
                              transition: color 0.3s;
                            }
                            color: ${toggleValue === "General Settings"
                              ? themeDefault?.info?.colorPrimary
                              : ""};
                            .ant-typography {
                              color: ${toggleValue === "General Settings"
                                ? themeDefault?.info?.colorPrimary
                                : ""};
                            }

                            &:hover {
                              color: ${themeDefault?.info?.colorPrimary};
                              .ant-typography {
                                color: ${themeDefault?.info?.colorPrimary};
                              }
                            }
                          `}
                        >
                          <ProfileCirlceIcon className="icon" />
                          <Text>
                            <TranslatorCompanyTag>
                              General Settings
                            </TranslatorCompanyTag>
                          </Text>
                        </div>
                      )}
                    </Col> */}
                    {/* <Col span={24}>
                      <Link onClick={handleLangClick} className={textHover}>
                        <GlobeIcon className="icon" />
                        {translations?.direction === "rtl" ? (
                          <Text>
                            <TranslatorCompanyTag>
                              Language :
                            </TranslatorCompanyTag>
                            {translations?.title === "ar" && `عربي `}
                          </Text>
                        ) : (
                          <Text>
                            <TranslatorCompanyTag>
                              Language:
                            </TranslatorCompanyTag>{" "}
                            {translations?.title
                              ? translations?.title === "en" && ` English`
                              : ` English`}
                          </Text>
                        )}
                      </Link>
                    </Col> */}

                    {/* <Col span={24}>
                      <Link
                        onClick={() => {
                          setViewThemeSettings(true);
                        }}
                        className={textHover}
                        // to={
                        //   sharedUserInfo?.payload?.type === "admin"
                        //     ? `/admin/theme-settings/`
                        //     : sharedUserInfo?.payload?.type !== "user"
                        //     ? `/manager/theme-settings/`
                        //     : sharedUserInfo?.payload?.type === "user"
                        //     ? `/user/theme-settings/`
                        //     : ""
                        // }
                      >
                        <BruchIcon className="icon" />
                        <Text>
                          <TranslatorCompanyTag>
                            Theme Settings
                          </TranslatorCompanyTag>
                        </Text>
                      </Link>
                    </Col> */}
                    <Col
                      style={{ marginBottom: "5px" }}
                      span={24}
                      className={textHover}
                      onClick={() => logoutFunction()}
                    >
                      <LogoutIcon className="icon" />
                      <Text>
                        <TranslatorCompanyTag>Log out</TranslatorCompanyTag>
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            {/* <Divider style={{ margin: "0px" }} /> */}
            <Col
              style={{}}
              span={24}
              className={css`
                background: ${themeDefault?.info?.newConfig
                  ?.profileDropDownSecondaryBackground};
                backdrop-filter: blur(50px);
                padding: 0 15px !important;
                padding-top: 10px !important;
                padding-bottom: 15px !important;

                border-radius: 0px 0px ${themeDefault?.info?.borderRadius}px
                  ${themeDefault?.info?.borderRadius}px;
              `}
            >
              <Text
                className={css`
                  cursor: pointer;
                  transition: color 0.3s;
                  .anchor {
                    text-decoration: none;
                    color: ${themeDefault?.info?.newConfig?.color};
                    transition: color 0.2s ease-in-out;
                    &:hover {
                      color: ${themeDefault?.info?.colorPrimary};
                    }
                  }
                  display: flex;
                  align-items: center;
                  gap: 10px;
                `}
              >
                <a
                  target="_blank"
                  href="https://maxhr.io/terms-of-service/"
                  className="anchor"
                >
                  <TranslatorCompanyTag>Terms</TranslatorCompanyTag>{" "}
                </a>
                <span
                  className={css`
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    background-color: ${themeDefault?.info?.colorPrimary};
                    border-radius: 50%;
                  `}
                />
                <a
                  target="_blank"
                  href="https://maxhr.io/privacy-policy/"
                  className="anchor"
                >
                  <TranslatorCompanyTag>Policy</TranslatorCompanyTag>
                </a>
              </Text>
            </Col>
          </Row>
        ) : viewCompanies ? (
          <Row
            className={css`
              display: flex;
              gap: clamp(3px, 0.33vw, 5px);
            `}
          >
            <Col
              span={24}
              className={css`
                padding: 5px 15px !important;
                border-bottom: ${themeDefault?.info?.newConfig
                  ?.cardborder} !important;
              `}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "5px",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                {translations?.direction === "rtl" ? (
                  <ArrowRightIcon
                    className="icon"
                    onClick={() => {
                      setViewCompanies(false);
                      setVisibleCompanies(5);
                    }}
                    style={{ fontSize: "20px" }}
                  />
                ) : (
                  <ArrowLeft
                    className="icon"
                    onClick={() => {
                      setViewCompanies(false);
                      setVisibleCompanies(5);
                    }}
                    style={{ fontSize: "20px" }}
                  />
                )}

                <Text>
                  <TranslatorCompanyTag>Switch Company</TranslatorCompanyTag>
                </Text>
              </div>
              <RepeatIcon style={{ fontSize: "16px" }} />
            </Col>
            <Col
              span={24}
              className={css`
                padding: 5px 15px !important;
              `}
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              {userType !== "admin"
                ? profileDDAllUserComp
                : profileDropDownAllCompanies}
            </Col>
          </Row>
        ) : viewThemeSettings ? (
          <Row
            className={css`
              display: flex;
              gap: clamp(3px, 0.33vw, 5px);
            `}
          >
            <Col
              span={24}
              className={css`
                padding: 5px 15px !important;
                border-bottom: ${themeDefault?.info?.newConfig
                  ?.cardborder} !important;
              `}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "5px",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                {translations?.direction === "rtl" ? (
                  <ArrowRightIcon
                    size="small"
                    onClick={() => {
                      setOpen(true);
                      setViewThemeSettings(false);
                    }}
                    className="icon"
                    style={{ fontSize: "20px" }}
                  />
                ) : (
                  <ArrowLeft
                    size="small"
                    onClick={() => {
                      setOpen(true);
                      setViewThemeSettings(false);
                    }}
                    className="icon"
                    style={{ fontSize: "20px" }}
                  />
                )}
                <Text>
                  <TranslatorCompanyTag>Theme Settings</TranslatorCompanyTag>
                </Text>{" "}
                {loading ? <CustomLoaderIcon size="small" /> : ""}
              </div>

              <CloseCircleIcon
                size="small"
                onClick={() => {
                  setOpen(false);
                  setViewThemeSettings(false);
                }}
              />
            </Col>
            <Col span={24}>
              <ThemeSettingsPopup viewThemeSettings={viewThemeSettings} />
            </Col>
          </Row>
        ) : viewLanguageSettings ? (
          <Row
            className={css`
              display: flex;
              gap: clamp(3px, 0.33vw, 5px);
              padding-bottom: 20px;
            `}
          >
            <Col
              span={24}
              className={css`
                padding: 5px 15px !important;
                border-bottom: ${themeDefault?.info?.newConfig
                  ?.cardborder} !important;
              `}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "5px",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                {translations?.direction === "rtl" ? (
                  <ArrowRightIcon
                    size="small"
                    onClick={() => {
                      setOpen(true);
                      setViewLanguageSettings(false);
                    }}
                    className="icon"
                    style={{ fontSize: "20px" }}
                  />
                ) : (
                  <ArrowLeft
                    size="small"
                    onClick={() => {
                      setOpen(true);
                      setViewLanguageSettings(false);
                    }}
                    className="icon"
                    style={{ fontSize: "20px" }}
                  />
                )}
                <Text>
                  <TranslatorCompanyTag>Select Language</TranslatorCompanyTag>
                </Text>{" "}
                {loading ? <CustomLoaderIcon size="small" /> : ""}
              </div>

              <CloseCircleIcon
                style={{ fontSize: "16px" }}
                onClick={() => {
                  setOpen(false);
                  setViewLanguageSettings(false);
                }}
              />
            </Col>
            <Col span={24}>
              <LangaugeSettingsPopup
                onClose={handleClose}
                onLanguageChange={handleLanguageChange}
              />
            </Col>
          </Row>
        ) : (
          <Row>
            <Col
              span={24}
              className={css`
                border-bottom: ${themeDefault?.info?.newConfig
                  ?.cardborder} !important;
              `}
            >
              <Row
                className={css`
                  padding: 0 15px !important;
                  padding-bottom: 2px !important;
                  padding-top: 10px !important;

                  display: flex;
                  gap: 10px;
                `}
              >
                <Col
                  className={css`
                    .ant-skeleton
                      .ant-skeleton-content
                      .ant-skeleton-paragraph {
                      margin: 0px;
                    }
                    .ant-skeleton
                      .ant-skeleton-content
                      .ant-skeleton-paragraph
                      > li {
                      height: 10px;
                    }
                  `}
                  span={24}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <Avatar
                    size={35}
                    shape="square"
                    style={{ background: "#260b3b", color: "white" }}
                    icon={
                      isDummyLogo ? (
                        <p
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            marginTop: "0px",
                            cursor: "pointer",
                            textTransform: "uppercase",
                          }}
                        >
                          {CompanyName?.slice(0, 2).toUpperCase()}
                        </p>
                      ) : (
                        <img
                          src={CompanyLogo?.url}
                          style={{ borderRadius: "8px" }}
                          alt="Profile Pic"
                        />
                      )
                    }
                  />
                  <Row
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems:
                        translations?.direction === "rtl" ? "0" : "flex-start",
                    }}
                  >
                    <Text style={{ fontWeight: 500 }}>{CompanyName}</Text>
                    <Col>
                      {allEmpLoading ? (
                        <Skeleton
                          active
                          title={false}
                          paragraph={{ rows: 1, width: "50%" }}
                        />
                      ) : (
                        allEmpInfo && (
                          <Text type="secondary">
                            {allEmpInfo.length}{" "}
                            <TranslatorCompanyTag>
                              Employees
                            </TranslatorCompanyTag>
                          </Text>
                        )
                      )}
                    </Col>
                  </Row>
                </Col>
                {userType !== "user" && (
                  <Col span={24}>
                    {}
                    <Row gutter={[8, 4]}>
                      <Col
                        // span={
                        //   userType === "admin" ||
                        //   (userType !== "user" && roleFeatures?.includes("1"))
                        //     ? 12
                        //     : 24
                        // }
                        span={24}
                      >
                        <Link
                          to={`/${
                            userType === "admin" ? userType : "manager"
                          }/organization-settings/`}
                        >
                          <Button
                            style={{
                              width: "100% ",
                              margin: "8px 0",
                            }}
                            icon={<NutIcon className="icon" />}
                          >
                            <TranslatorCompanyTag>
                              Org. Setting
                            </TranslatorCompanyTag>
                          </Button>
                        </Link>
                      </Col>
                      {userType === "admin" ||
                      (userType !== "user" && roleFeatures?.includes("1")) ? (
                        <Col span={12}>
                          {/* <TeamInviteModal type="button" /> */}
                        </Col>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </Col>
                )}
              </Row>
            </Col>
            {/* <Divider style={{ margin: "0px" }} /> */}
            {userType === "admin" && (
              <>
                {archiveCompanyInfo?.length > 1 ||
                getAllCompaniesInfo?.length > 1 ? (
                  <Col
                    span={24}
                    className={css`
                      background: ${themeDefault?.info?.newConfig
                        ?.profileDropDownSecondaryBackground};
                      backdrop-filter: blur(50px);
                      border-bottom: ${themeDefault?.info?.newConfig
                        ?.cardborder} !important;
                    `}
                  >
                    <Row
                      className={css`
                        padding: 0 15px !important;
                        padding-bottom: 0px !important;
                        display: flex;
                        gap: clamp(3px, 0.33vw, 5px);
                      `}
                    >
                      <Col
                        span={24}
                        style={{
                          marginTop: "5px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text>
                          <TranslatorCompanyTag>
                            Switch Company
                          </TranslatorCompanyTag>
                        </Text>
                        <RepeatIcon size="small" />
                      </Col>

                      <Col span={24}>
                        {profileDropDownCompanies}
                        {allCompanies.length > visibleCompanies && (
                          <div
                            style={{
                              margin: "5px 0",
                            }}
                          >
                            <Text
                              className={css`
                                &:hover {
                                  .ant-typography {
                                    color: ${themeDefault?.info?.newConfig
                                      ?.colorPrimary};
                                  }
                                }
                              `}
                              onClick={() => {
                                const allComp =
                                  (getAllCompaniesInfo?.length > 0
                                    ? getAllCompaniesInfo
                                    : archiveCompanyInfo?.length > 0
                                    ? archiveCompanyInfo
                                    : []) || [];
                                setVisibleCompanies(allComp);
                                // setVisibleCompanies(companyData.lenght);
                                setViewCompanies(true);
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                              }}
                            >
                              <TranslatorCompanyTag>
                                Show More
                              </TranslatorCompanyTag>
                            </Text>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  ""
                )}
              </>
            )}
            {/* <Divider style={{ margin: "0px" }} /> */}
            {userType !== "admin" && (
              <>
                {getUserCompaniesInfo?.length > 1 ? (
                  <Col
                    span={24}
                    className={css`
                      background: ${themeDefault?.info?.newConfig
                        ?.profileDropDownSecondaryBackground};
                      backdrop-filter: blur(50px);
                      border-bottom: ${themeDefault?.info?.newConfig
                        ?.cardborder} !important;
                    `}
                  >
                    <Row
                      className={css`
                        padding: 0 15px !important;
                        padding-bottom: 0px !important;
                        display: flex;
                        gap: clamp(3px, 0.33vw, 5px);
                      `}
                    >
                      <Col
                        span={24}
                        style={{
                          marginTop: "5px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text>
                          <TranslatorCompanyTag>
                            Switch Company
                          </TranslatorCompanyTag>
                        </Text>
                        <RepeatIcon size="small" />
                      </Col>

                      <Col span={24}>
                        {profileDDUserComp}
                        {AllUserComp.length > visibleCompanies && (
                          <div
                            style={{
                              margin: "5px 0",
                            }}
                          >
                            <Text
                              className={css`
                                &:hover {
                                  .ant-typography {
                                    color: ${themeDefault?.info?.newConfig
                                      ?.colorPrimary};
                                  }
                                }
                              `}
                              onClick={() => {
                                const allComp =
                                  (getUserCompaniesInfo?.length > 0
                                    ? getUserCompaniesInfo
                                    : []) || [];
                                setVisibleCompanies(allComp);
                                // setVisibleCompanies(companyData.lenght);
                                setViewCompanies(true);
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                              }}
                            >
                              <TranslatorCompanyTag>
                                Show More
                              </TranslatorCompanyTag>
                            </Text>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  ""
                )}
              </>
            )}
            <Col
              span={24}
              className={css`
                background: transparent;
                backdrop-filter: blur(10px);
                border-bottom: ${themeDefault?.info?.newConfig
                  ?.cardborder} !important;
              `}
            >
              <Row
                className={css`
                  padding: 0 15px !important;
                  padding-bottom: 0px !important;
                  padding-top: 5px !important ;
                  display: flex;
                  gap: clamp(3px, 0.33vw, 5px);
                `}
              >
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <Text>{userEmail}</Text>
                </Col>
                <Col span={24}>
                  <Row>
                    {/* <Col span={24}>
                      {userType !== "user" ? (
                        <Link
                          className={textHover}
                          to={
                            sharedUserInfo?.payload?.type === "admin"
                              ? `/admin/settings/`
                              : sharedUserInfo?.payload?.type !== "user"
                              ? `/manager/settings/`
                              : sharedUserInfo?.payload?.type === "user"
                              ? `/user/settings/`
                              : ""
                          }
                        >
                          <ProfileCirlceIcon className="icon" />
                          <Text>
                            <TranslatorCompanyTag>
                              Profile Settings
                            </TranslatorCompanyTag>
                          </Text>
                        </Link>
                      ) : (
                        <div
                          onClick={() => {
                            setOpen(false);
                            router("/user/general-settings");
                          }}
                          className={css`
                            display: flex !important;
                            cursor: pointer;

                            padding: 3px 0;
                            gap: clamp(4px, 0.7vw, 12px);
                            transition: border 0.3s, color 0.3s;
                            .ant-typography {
                              transition: color 0.3s;
                            }
                            color: ${toggleValue === "General Settings"
                              ? themeDefault?.info?.colorPrimary
                              : ""};
                            .ant-typography {
                              color: ${toggleValue === "General Settings"
                                ? themeDefault?.info?.colorPrimary
                                : ""};
                            }

                            &:hover {
                              color: ${themeDefault?.info?.colorPrimary};
                              .ant-typography {
                                color: ${themeDefault?.info?.colorPrimary};
                              }
                            }
                          `}
                        >
                          <ProfileCirlceIcon className="icon" />
                          <Text>
                            <TranslatorCompanyTag>
                              General Settings
                            </TranslatorCompanyTag>
                          </Text>
                        </div>
                      )}
                    </Col> */}
                    <Col span={24}>
                      {/* <Popover
                        content={
                          <LangaugeSettingsPopup
                            onClose={handleClose}
                            onLanguageChange={handleLanguageChange}
                          />
                        }
                        trigger="click"
                        visible={viewLanguageSettings}
                        onVisibleChange={setViewLanguageSettings}
                      > */}
                      <Link onClick={handleLangClick} className={textHover}>
                        <GlobeIcon className="icon" />
                        {translations?.direction === "rtl" ? (
                          <Text>
                            <TranslatorCompanyTag>
                              Language :
                            </TranslatorCompanyTag>
                            {translations?.title === "ar" && `عربي `}
                          </Text>
                        ) : (
                          <Text>
                            <TranslatorCompanyTag>
                              Language:
                            </TranslatorCompanyTag>{" "}
                            {translations?.title
                              ? translations?.title === "en" && ` English`
                              : ` English`}
                          </Text>
                        )}
                      </Link>
                      {/* </Popover> */}
                    </Col>

                    <Col span={24}>
                      <Link
                        onClick={() => {
                          setViewThemeSettings(true);
                        }}
                        className={textHover}
                        // to={
                        //   sharedUserInfo?.payload?.type === "admin"
                        //     ? `/admin/theme-settings/`
                        //     : sharedUserInfo?.payload?.type !== "user"
                        //     ? `/manager/theme-settings/`
                        //     : sharedUserInfo?.payload?.type === "user"
                        //     ? `/user/theme-settings/`
                        //     : ""
                        // }
                      >
                        <BruchIcon className="icon" />
                        <Text>
                          <TranslatorCompanyTag>
                            Theme Settings
                          </TranslatorCompanyTag>
                        </Text>
                      </Link>
                    </Col>
                    <Col
                      style={{ marginBottom: "5px" }}
                      span={24}
                      className={textHover}
                      onClick={() => logoutFunction()}
                    >
                      <LogoutIcon className="icon" />
                      <Text>
                        <TranslatorCompanyTag>Log out</TranslatorCompanyTag>
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            {/* <Divider style={{ margin: "0px" }} /> */}
            <Col
              style={{}}
              span={24}
              className={css`
                background: ${themeDefault?.info?.newConfig
                  ?.profileDropDownSecondaryBackground};
                backdrop-filter: blur(50px);
                padding: 0 15px !important;
                padding-top: 10px !important;
                padding-bottom: 15px !important;

                border-radius: 0px 0px ${themeDefault?.info?.borderRadius}px
                  ${themeDefault?.info?.borderRadius}px;
              `}
            >
              <Text
                className={css`
                  cursor: pointer;
                  transition: color 0.3s;
                  .anchor {
                    text-decoration: none;
                    color: ${themeDefault?.info?.newConfig?.color};
                    transition: color 0.2s ease-in-out;
                    &:hover {
                      color: ${themeDefault?.info?.colorPrimary};
                    }
                  }
                  display: flex;
                  align-items: center;
                  gap: 10px;
                `}
              >
                <a
                  target="_blank"
                  href="https://maxhr.io/terms-of-service/"
                  className="anchor"
                >
                  <TranslatorCompanyTag>Terms</TranslatorCompanyTag>{" "}
                </a>
                <span
                  className={css`
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    background-color: ${themeDefault?.info?.colorPrimary};
                    border-radius: 50%;
                  `}
                />
                <a
                  target="_blank"
                  href="https://maxhr.io/privacy-policy/"
                  className="anchor"
                >
                  <TranslatorCompanyTag>Policy</TranslatorCompanyTag>
                </a>
              </Text>
            </Col>
          </Row>
        )}
      </div>
    );
  };

  return (
    <>
      <div
        className={css`
          .ant-popover .ant-popover-placement-bottom {
            background-color: transparent !important;
            backdrop-filter: blur(50px);
          }
        `}
      >
        {sharedUserInfo?.payload?.type === "admin" ||
        sharedUserInfo?.payload?.type !== "admin" ? (
          getAllCompaniesInfo?.length > 0 ||
          sharedUserInfo?.payload?.type !== "admin" ? (
            getAllCompaniesLoading || openAnotherCompanyLoading ? (
              <div
                className={css`
                  .ant-skeleton.ant-skeleton-element {
                    display: flex;
                  }
                `}
              >
                <Skeleton.Avatar active />
              </div>
            ) : (
              <div>
                <Popover
                  width={500}
                  content={DropDown}
                  trigger="click"
                  open={open}
                  style={{
                    width: "300px",
                    background: "transparent",
                    backdropFilter: "blur(50px)",
                    padding: 0,
                  }}
                  overlayInnerStyle={{
                    // background:
                    //   themeDefault?.info?.newConfig?.components?.Table
                    //     ?.colorBgContainer,
                    background: "transparent",
                    padding: "0",
                  }}
                  overlayStyle={{ padding: "0" }}
                  onOpenChange={handleOpenChange}
                  placement="bottomLeft"
                >
                  <Avatar
                    className={css`
                      position: absolute;
                      min-width: 16px;
                      border-radius: 100%;
                      top: ${props.fromOnboarding ? "30px" : "20px"} !important;
                      width: 25px;
                      height: 25px;
                      @media (max-width: 1600px) {
                        width: 20px;
                        height: 20px;
                      }
                      @media (max-width: 1500px) {
                        width: 18px;
                        height: 18px;
                        top: ${props.fromOnboarding
                          ? "30px"
                          : "15px"} !important;
                        right: ${props.fromOnboarding ? "15px" : ""} !important;
                      }
                      right: ${props.fromOnboarding
                        ? "15px"
                        : translations?.direction === "ltr"
                        ? "30px"
                        : "0"} !important;
                      left: ${props.fromOnboarding
                        ? ""
                        : translations?.direction === "rtl"
                        ? "30px"
                        : "0"} !important;
                      // right: 30px !important;
                      z-index: 1;
                    `}
                    style={{
                      background: employeeColor,
                      color: textColor,
                      cursor: "pointer",
                    }}
                    icon={
                      isDummyLogo ? (
                        <p
                          style={{
                            fontSize: "10px",
                            fontWeight: "normal",
                            marginTop: "0px",
                            cursor: "pointer",
                            textTransform: "uppercase",
                          }}
                        >
                          {companyInitials}
                        </p>
                      ) : (
                        <img
                          src={CompanyLogo?.url}
                          alt="Profile Pic"
                          style={{ borderRadius: "8px" }}
                        />
                      )
                    }
                  />
                  <Avatar
                    className={css`
                      width: 40px;
                      height: 40px;
                      @media (max-width: 1600px) {
                        width: 35px;
                        height: 35px;
                      }
                      @media (max-width: 1500px) {
                        width: 30px;
                        height: 30px;
                      }
                    `}
                    style={{
                      cursor: "pointer",
                      background: "#260b3b",
                      color: "white",
                    }}
                    icon={
                      isDummypfp ? (
                        <p
                          style={{
                            fontSize: "12px",
                            fontWeight: "normal",
                            marginTop: "0px",
                            cursor: "pointer",
                            textTransform: "uppercase",
                          }}
                        >
                          {userInitials}
                        </p>
                      ) : (
                        <img src={profileImage?.url} alt="Profile Pic" />
                      )
                    }
                  />
                </Popover>
              </div>
            )
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default ProfileDropDown;
